import { useEffect, useState } from 'react';
import { ATALHOS, atalhoAtivo, diasEntre, hojeLocal, usePeriodo } from '../lib/periodo';

const MAX_DIAS = 93;

export function SeletorPeriodo() {
  const [periodo, mudar] = usePeriodo();
  const [de, setDe] = useState(periodo.de);
  const [ate, setAte] = useState(periodo.ate);
  // segue a URL quando ela muda por fora (voltar do navegador, link colado)
  useEffect(() => {
    setDe(periodo.de);
    setAte(periodo.ate);
  }, [periodo.de, periodo.ate]);
  const ativo = atalhoAtivo(periodo);
  const valido = de && ate && de <= ate && diasEntre({ de, ate }) <= MAX_DIAS;

  return (
    <div className="periodo" role="group" aria-label="Período">
      <div className="atalhos">
        {ATALHOS.map((a) => (
          <button
            key={a.id}
            type="button"
            aria-pressed={ativo === a.id}
            onClick={() => {
              const p = a.periodo();
              setDe(p.de);
              setAte(p.ate);
              mudar(p);
            }}
          >
            {a.rotulo}
          </button>
        ))}
      </div>
      <form
        className="datas"
        onSubmit={(e) => {
          e.preventDefault();
          if (valido) mudar({ de, ate });
        }}
      >
        <label>
          De <input type="date" value={de} max={hojeLocal()} onChange={(e) => setDe(e.target.value)} />
        </label>
        <label>
          Até <input type="date" value={ate} max={hojeLocal()} onChange={(e) => setAte(e.target.value)} />
        </label>
        <button type="submit" disabled={!valido || (de === periodo.de && ate === periodo.ate)}>
          Aplicar
        </button>
        {!valido && <span className="mudo">Até {MAX_DIAS} dias, com início antes do fim.</span>}
      </form>
    </div>
  );
}
